import '../../../App.css';
import { alpha } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import { Actions, EntryContext, useSubState } from '../shared/State';
import { CollapsableDiv } from '../shared/SharedComponents';
import ZetronHub from '../../../features/SignalR/ZetronHub';
import { useEffect, useRef } from 'react';
import { useGetWeatherInfoQuery } from '../../../features/weather/WeatherSlice';
import { useLocation } from 'react-router-dom';

export const ConfinedSpaceMonitoringDiv = ({ }: {}) => {
    const { t, i18n } = useTranslation();
    const [entryContext, confinedSpaceStatus] = useSubState(EntryContext, x => x.confinedSpaceStatus!)
    const [_, siteEquipments] = useSubState(EntryContext, x => x.siteEquipments!)
    // console.log('render confined')

    const zetronHubRef = useRef<signalR.HubConnection | null>(null)

    useEffect(() => {
        const zetronEquipmentIds = siteEquipments?.filter((x: any) => x.realTimeResourceTypeId === 5)?.map((x: any) => x.serialNumber);//id

        if (zetronEquipmentIds) {
            zetronEquipmentIds.forEach((equipmentId: any) => {
                if (equipmentId) {
                    zetronHubRef.current = ZetronHub({
                        sn: equipmentId,
                        setZetronData: (data: any) => {
                            entryContext!.update(Actions.updateZetronSensor(data));
                        }
                    })
                }
            });
        }

        return () => {
            if (zetronHubRef.current != null)
                zetronHubRef.current.stop()
        }
    }, [siteEquipments])
    const getLocation = useLocation()
    const schedule = getLocation.state?.schedule;

    return (
        <CollapsableDiv
            title={t(" Monitoring")}>
            <div
                // onClick={() => {
                //     entryContext?.update(Actions.location())
                // }}
                style={{ backgroundColor: alpha("#052A70", 0.5), paddingLeft: '10px', paddingRight: '10px', paddingTop: '5px', paddingBottom: '5px' }}>
                <div style={{ marginBottom: '10px', }}>{t("PM2.5")}: <span style={{ color: '#3EDF24' }}>{confinedSpaceStatus.pm2_5}</span> ug/m³</div>
                <div>{t("temperature")}: <span style={{ color: '#3EDF24' }}>{confinedSpaceStatus.temperature}</span> °C</div>
            </div>
        </CollapsableDiv >
    )
}